@switch (mode()) {
  @case('left') {
    <div class="flex flex-row items-center">
      <div class="bg-white h-9 rounded-xl">
        <ng-container *ngTemplateOutlet="leftButton"></ng-container>
      </div>

      <div class="w-px"></div>

      <div class="w-9"></div>
    </div>
  }
  @case('right') {
    <div class="flex flex-row items-center">
      <div class="w-9"></div>

      <div class="w-px"></div>

      <div class="bg-white w-9 h-9 rounded-xl">
        <ng-container *ngTemplateOutlet="rightButton"></ng-container>
      </div>
    </div>
  }
  @case('both') {
    <div class="bg-white h-9 rounded-xl flex flex-row items-center" style="width: 4.5rem + 1px">
      <ng-container *ngTemplateOutlet="leftButton"></ng-container>

      <div class="h-6 w-px bg-[#ECECEC]"></div>

      <ng-container *ngTemplateOutlet="rightButton"></ng-container>
    </div>
  }
}

<ng-template #leftButton>
  <div>
    <button class="flex-initial h-9 w-9 rounded-xl grid items-center justify-items-center" (click)="onLeftPressed()">
      <img [src]="'/assets/icons/arrow-left.svg'" class="h-5 w-5" style="filter: brightness(0) saturate(100%) invert(6%) sepia(8%) saturate(7498%) hue-rotate(192deg) brightness(99%) contrast(94%);">
    </button>
  </div>
</ng-template>

<ng-template #rightButton>
  <div>
    <button class="flex-initial h-9 w-9 rounded-xl grid items-center justify-items-center" (click)="onRightPressed()">
      <img [src]="'/assets/icons/arrow-right.svg'" class="h-5 w-5" style="filter: brightness(0) saturate(100%) invert(6%) sepia(8%) saturate(7498%) hue-rotate(192deg) brightness(99%) contrast(94%);">
    </button>
  </div>
</ng-template>
